if (/Trident\/|MSIE/.test(window.navigator.userAgent)) {
  console.log('Browser Unsupported');

  const body = document.body;

  const notSupportedNode = document.createElement('div');

  notSupportedNode.innerHTML = 'Your browser is not supported.';
  notSupportedNode.style.fontSize = '1.5rem';
  notSupportedNode.style.fontFamily = '"Lato", sans-serif;';
  notSupportedNode.style.textAlign = 'center';
  notSupportedNode.style.marginTop = '4rem';

  body.innerHTML = '';
  body.appendChild(notSupportedNode);
}

// Fix Windows screen zoom
if (screen.width > 1200) {
  document
    .querySelector('meta[name=viewport]')
    .setAttribute('content', 'width=device-width, initial-scale=' + 1 / window.devicePixelRatio);
}

jQuery(document).ready(function ($) {
  // Remove empty P tags created by WP inside of Accordion and Orbit
  $('.accordion p:empty, .orbit p:empty').remove();
  // Adds Flex Video to YouTube and Vimeo Embeds
  $('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]').each(function () {
    if ($(this).innerWidth() / $(this).innerHeight() > 1.5) {
      $(this).wrap("<div class='widescreen responsive-embed'/>");
    } else {
      $(this).wrap("<div class='responsive-embed'/>");
    }
  });
  // ACF Menu
  acfMenu();

  function acfMenu() {
    let tab = $('.acf-menu__nav-item');
    let tabPanel = $('.acf-menu__nav-content');
    tab.first().addClass('active');
    tabPanel.first().addClass('active');
    tab.on('click', function (event) {
      $(this).addClass('active').siblings().removeClass('active');
      tabPanel.removeClass('active').eq($(this).index()).addClass('active');
    });
  }

  function updateScrollPosition(selector) {
    var element = document.querySelector(selector);

    if (element) {
      const offset = 100;

      const { top } = element.getBoundingClientRect();
      const { scrollY } = window;

      const rawPosition = top + scrollY;

      const position = rawPosition - offset;

      window.scrollTo({
        top: position,
        behavior: 'auto',
      });
    }
  }

  function handleHashLinks() {
    const links = document.querySelectorAll('.acf-menu-mobile__item .submenu a');

    links.forEach(link => {
      const worker = event => {
        const { target } = event;
        const { pathname } = window.location;

        const targetUrl = new URL(target.href);
        const targetPath = targetUrl.pathname;
        const hash = targetUrl.hash;

        if (pathname !== targetPath) return;

        if (hash) {
          event.preventDefault();
          updateScrollPosition(hash);

          $('#offCanvasOverlap').foundation('close');
        }
      };

      link.removeEventListener('click', worker);
      link.addEventListener('click', worker, { once: true });
    });
  }

  handleHashLinks();

  $('.acf-menu__submenu li a').on('click', function (event) {
    event.preventDefault();
    let target = this.hash;
    let link = this.href;
    let uriItem = this.href.split('#')[0];
    let uri = window.location.href.split('#')[0];
    $target = $(target);
    if (target && $target.length && uri === uriItem) {
      $('.acf-menu').fadeOut();
      $('.ani').removeClass('ani_visible');
      $('.header').removeClass('overlay');
      $('html, body')
        .stop()
        .animate(
          {
            scrollTop: $target.offset().top - 120,
          },
          500,
          'swing',
        );
    } else {
      window.location.replace(link);
      if (target && $target.length) {
        $('html, body')
          .stop()
          .animate(
            {
              scrollTop: $target.offset().top - 120,
            },
            500,
            'swing',
          );
      }
    }
  });
  // // Custom checkbox for ASP
  // $('.asp_option_cff').each(function () {
  // 	$(this).find('input + label').remove();
  // 	$(this).find('.asp_option_inner').removeClass('asp_option_inner').addClass('custom-checkbox-container').append('<div></div>');
  // });
  $('.footer-show-menu-search').on('submit', function (event) {
    event.preventDefault();
    openSearch();
    ASP.api(3, 'searchFor', $('.footer-show-menu-search__text').val());
  });

  $('.button-show-menu-search').click(function () {
    var searchBlock = $('#ebrd-search-modal');

    if (searchBlock.hasClass('opened')) {
      closeSearch();
    } else {
      openSearch();
    }
  });

  $('.button-close-menu-search').click(function () {
    closeSearch();
  });

  $('.acf-menu-button').click(function () {
    closeSearch();
    $('.acf-menu').animate(
      {
        height: 'toggle',
      },
      400,
      function () {
        $('.ani').toggleClass('ani_visible');
        $('.header').toggleClass('overlay');
        $('.fc-editor img').each(function () {
          $(this).attr('src', $(this).data('src'));
        });
      },
    );
  });

  function openSearch() {
    var showSearchButton = $('.button-show-menu-search'),
      searchBlock = $('#ebrd-search-modal');

    if (searchBlock.hasClass('opened')) return false;

    closeMenu();
    showSearchButton.addClass('active');
    searchBlock.addClass('opened');
    $('body').css('overflow-y', 'hidden');
    updateSearchOffset();
    $('.footer-search').fadeIn();
    ASP.api(3, 'searchFor', '');
  }

  function updateSearchOffset() {
    var searchRightOffset =
      $(window).width() -
      ($('.button-show-menu-search').offset().left + $('.button-show-menu-search').outerWidth()) -
      25;
    $('.footer-search').css('right', searchRightOffset + 'px');
  }

  function closeSearch() {
    $('.button-show-menu-search').removeClass('active');
    $('#ebrd-search-modal').removeClass('opened');
    $('.footer-search').fadeOut();
    $('body').css('overflow-y', 'auto');
  }

  function closeMenu() {
    $('body').css('overflow-y', 'auto');
    $('.acf-menu').fadeOut();
    $('.ani').removeClass('ani_visible');
    $('.header').removeClass('overlay');
  }

  $(document).on('keydown', function (e) {
    if (e.keyCode === 27) {
      closeMenu();
      closeSearch();
    }
  });
  $(window).on('resize', function () {
    updateSearchOffset();

    let win = $(this);
    if (win.width() >= 1024 && $('.off-canvas').hasClass('is-open')) {
      $('.off-canvas').addClass('is-closed').removeClass('is-open');
      $('.acf-menu').show();
      $('.ani').addClass('ani_visible');
      $('.header').addClass('overlay');
      $('.js-off-canvas-overlay').removeClass('is-visible is-closable');
    }
    if (win.width() < 1024 && $('.header').hasClass('overlay')) {
      $('.acf-menu').hide();
      $('.ani').removeClass('ani_visible');
      $('.header').removeClass('overlay');
      $('.off-canvas').removeClass('is-closed').addClass('is-open');
      $('.js-off-canvas-overlay').addClass('is-visible is-closable');
    }
  });
  if ($('.swiper-container').length) {
    let mySwiper = new Swiper('.swiper-container', {
      loop: true,
      navigation: {
        nextEl: '.swiper-button_next',
        prevEl: '.swiper-button_prev',
      },
      pagination: {
        el: '.swiper-pagination',
      },
    });
  }
  $('.button-to-top').on('click', function (e) {
    $('html, body').animate(
      {
        scrollTop: 0,
      },
      700,
    );
  });

  // Scroll Indicator
  window.onscroll = function () {
    var winScroll = document.body.scrollTop || document.documentElement.scrollTop;
    var height = document.documentElement.scrollHeight - document.documentElement.clientHeight;
    var scrolled = (winScroll / height) * 100;
    document.getElementById('ebrd-scroll-indicator').style.width = scrolled + '%';
  };
});
